import React from 'react';
import { PS } from '../theme';

export default function CircleReviews({ reviews, fallbackRating, fallbackReviews, canReview, onWrite }) {
  const list = reviews?.reviews || [];
  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', padding: '0 20px 10px' }}>
        <div style={{ fontSize: 15, fontWeight: 600 }}>รีวิวท้าวแชร์</div>
        <div style={{ marginLeft: 8, fontSize: 13, color: PS.gold, fontWeight: 600 }}>★ {reviews?.avg || fallbackRating} <span style={{ color: PS.textMuted, fontWeight: 400 }}>({reviews?.count ?? fallbackReviews})</span></div>
        {canReview && (
          <button data-testid="detail-review-btn" onClick={onWrite} className="ps-press" style={{ marginLeft: 'auto', background: 'transparent', border: `1px solid ${PS.line}`, borderRadius: 999, padding: '6px 14px', fontSize: 12, fontWeight: 600, color: PS.text, fontFamily: PS.fontUI }}>{reviews?.my_review ? 'แก้ไขรีวิว' : 'ให้ดาว'}</button>
        )}
      </div>
      <div style={{ margin: '0 16px 16px' }}>
        {list.length ? (
          <div style={{ background: PS.surface, border: `1px solid ${PS.line}`, borderRadius: 18, overflow: 'hidden' }}>
            {list.slice(0, 4).map((rv, i, arr) => (
              <div key={rv.review_id || i} data-testid={`review-row-${i}`} style={{ padding: '12px 16px', borderBottom: i < Math.min(arr.length, 4) - 1 ? `1px solid ${PS.lineSoft}` : 'none' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div style={{ fontSize: 12.5, fontWeight: 600, flex: 1 }}>{rv.user_name}</div>
                  <div style={{ color: PS.gold, fontSize: 12 }}>{'★'.repeat(rv.rating)}<span style={{ color: PS.line }}>{'★'.repeat(5 - rv.rating)}</span></div>
                </div>
                {rv.comment && <div style={{ fontSize: 12, color: PS.textMuted, marginTop: 4, lineHeight: 1.5 }}>{rv.comment}</div>}
              </div>
            ))}
          </div>
        ) : (
          <div style={{ padding: '16px', textAlign: 'center', fontSize: 12.5, color: PS.textMuted, background: PS.surface, border: `1px solid ${PS.line}`, borderRadius: 18 }}>ยังไม่มีรีวิว — เป็นคนแรกที่ให้ดาวท้าวคนนี้</div>
        )}
      </div>
    </>
  );
}
